import { ChangeDetectorRef, Component, OnInit, viewChild, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SharedService } from 'src/app/core/services/shared.service';
import { environment } from 'src/environments/environment.prod';
import { HeaderComponent } from '../header/header.component';
import { HeaderModule } from '../header/header.module';
import { Subscription } from 'rxjs';
import { BnNgIdleService } from 'bn-ng-idle';

@Component({
  selector: 'app-wall',
  standalone: true,
  templateUrl: './wall.component.html',
  styleUrls: ['./wall.component.scss'],
  // TODO: This component has been partially migrated to be zoneless-compatible.
  // After testing, this should be updated to ChangeDetectionStrategy.OnPush.
  imports: [HeaderModule, RouterOutlet],
})
export class WallComponent implements OnInit {
  private router = inject(Router);
  private sharedService = inject(SharedService);
  private cd = inject(ChangeDetectorRef);
  private route = inject(ActivatedRoute);
  private bnIdle = inject(BnNgIdleService);

  userDetailsData: any;
  roles: any[] = [];
  entities: any[] = [];
  entityRoles: any[] = [];
  roleAndFeatures: any[] = [];
  links: any[] = [];
  maintenanceEnabled = false;
  readonly headerComp = viewChild(HeaderComponent);
  private refreshSubscription: Subscription;
  unAuthFlag = true;

  constructor() {
    this.bnIdle.startWatching(Number(environment.idlesessiontime)).subscribe({
      next: (res) => {
        if (res) {
          alert('Your session has expired. Please relogin');
          localStorage.clear();
          this.headerComp().logout();
        }
      },
      error: (_err) => {},
    });
  }

  ngOnInit(): void {
    console.log(
      'On login user details api is called then section json routing will happen based on tabs selection on header.',
    );
    this.userdetails();
  }

  userdetails() {
    this.sharedService.getUserDetails().subscribe(
      (data) => {
        console.log(data);
        if (data) {
          this.userDetailsData = data;
          this.roles = this.userDetailsData['roles'];
          this.entities = this.userDetailsData['entities'];
          this.entityRoles = this.userDetailsData['entityRoles'];
          this.sharedService.changedRoleDetails(this.entityRoles);
          this.cd.markForCheck();
          this.roleAndFeatures = this.userDetailsData['roleAndFeatures'];
          this.links = this.userDetailsData['links'];
          localStorage.setItem('vendorName', this.userDetailsData['vendorName']);
        }
      },
      (_error) => {
        // console.log("error in user details api");
        const info = {
          msg: 'Technical issue occured, please try again later',
          isSuccess: false,
        };
        this.sharedService.openSnackBar(info, 'success-snack');
      },
    );
  }

  homeEvent(event) {
    if (event) {
      this.headerComp().tabChanged(0);
      this.headerComp().selectedTabIndex = 0;
    }
  }

  checkMaintenanceMode(event) {
    this.cd.markForCheck();
    this.maintenanceEnabled = event;
  }
}
